export const URL =
    process.env.NODE_ENV === "production"
        ? window.location.origin
        : "https://eqdom.xmen.seven-app.org";
export const BACKEND_URL = `${URL}/api/v1`;
export const API = "API";
export const API_START = "API_START";
export const API_END = "API_END";
export const ACCESS_DENIED = "ACCESS_DENIED";
export const TOKEN_EXPIRED = "TOKEN_EXPIRED";
export const API_ERROR = "API_ERROR";
export const CLEAR_DECONNEXION = "CLEAR_DECONNEXION";

export const GET_FAQS = "GET_FAQS";
export const SET_FAQS = "SET_FAQS";

export const SEND_SIMULATION = "SEND_SIMULATION";
export const SET_SIMULATION = "SET_SIMULATION";
export const CLEAR_SIMULATION = "CLEAR_SIMULATION";

export const SEND_SIMULATION_AUTO = "SEND_SIMULATION_AUTO";
export const SET_SIMULATION_AUTO = "SET_SIMULATION_AUTO";

export const GET_PROFESSIONS = "GET_PROFESSIONS";
export const SET_PROFESSIONS = "SET_PROFESSIONS";
export const GET_PROFESSION_BAREME = "GET_PROFESSION_BAREME";
export const SET_PROFESSION_BAREME = "SET_PROFESSION_BAREME";

export const SEND_AUTH = "SEND_AUTH";
export const SEND_AUTH_TOKEN = "SEND_AUTH_TOKEN";
export const SET_AUTH = "SET_AUTH";

export const SEND_VERIFY_OTP = "SEND_VERIFY_OTP";
export const SET_VERIFY_OTP = "SET_VERIFY_OTP";

export const SEND_VERIFY_OTP_INSCRIPTION = "SEND_VERIFY_OTP_INSCRIPTION";
export const SET_VERIFY_OTP_INSCRIPTION = "SET_VERIFY_OTP_INSCRIPTION";

export const ADD_CLIENT = "ADD_CLIENT";
export const SET_CLIENT = "SET_CLIENT";
export const CLEAR_CLIENT = "CLEAR_CLIENT";

export const SEND_DEMANDE_PRET = "SEND_DEMANDE_PRET";
export const SET_DEMANDE_PRET = "SET_DEMANDE_PRET";
export const CLEAR_DEMANDE_PRET = "CLEAR_DEMANDE_PRET";

export const CHANGE_PASSWORD = "CHANGE_PASSWORD";
export const SET_CHANGE_PASSWORD = "SET_CHANGE_PASSWORD";
export const CLEAR_CHANGE_PASSWORD = "CLEAR_CHANGE_PASSWORD";

export const VERIFY_OTP_PASSWORD = "VERIFY_OTP_PASSWORD";
export const SET_VERIFY_OTP_PASSWORD = "SET_VERIFY_OTP_PASSWORD";
export const CLEAR_VERIFY_OTP_PASSWORD = "CLEAR_VERIFY_OTP_PASSWORD";

export const UPDATE_PHONE = "UPDATE_PHONE";
export const SET_UPDATE_PHONE = "SET_UPDATE_PHONE";
export const CLEAR_UPDATE_PHONE = "CLEAR_UPDATE_PHONE";

export const VERIFY_OTP_PHONE = "VERIFY_OTP_PHONE";
export const SET_VERIFY_OTP_PHONE = "SET_VERIFY_OTP_PHONE";
export const CLEAR_VERIFY_OTP_PHONE = "CLEAR_VERIFY_OTP_PHONE";

export const UPDATE_MAIL = "UPDATE_MAIL";
export const SET_UPDATE_MAIL = "SET_UPDATE_MAIL";
export const CLEAR_UPDATE_MAIL = "CLEAR_UPDATE_MAIL";

export const VERIFY_OTP_MAIL = "VERIFY_OTP_MAIL";
export const SET_VERIFY_OTP_MAIL = "SET_VERIFY_OTP_MAIL";
export const CLEAR_VERIFY_OTP_MAIL = "CLEAR_VERIFY_OTP_MAIL";

export const GET_DONNEES_COMPTE = "GET_DONNEES_COMPTE";
export const SET_DONNEES_COMPTE = "SET_DONNEES_COMPTE";

export const ADD_RECLAMATION = "ADD_RECLAMATION";
export const SET_ADD_RECLAMATION = "SET_ADD_RECLAMATION";
export const CLEAR_ADD_RECLAMATION = "CLEAR_ADD_RECLAMATION";

export const GET_AGENCES = "GET_AGENCES";
export const SET_AGENCES = "SET_AGENCES";
export const SET_SIM_RESULT = "SET_SIM_INPUTS";
export const CLEAR_SIM_RESULT = "CLEAR_SIM_RESULT";

export const GET_DOCUMENTS = "GET_DOCUMENTS";
export const SET_DOCUMENTS = "SET_DOCUMENTS";

export const UPLOAD_DOCUMENT_PIECE = "UPLOAD_DOCUMENT_PIECE";
export const SET_UPLOAD_DOCUMENT_PIECE = "SET_UPLOAD_DOCUMENT_PIECE";

export const UPDATE_DOCUMENT_PIECE = "UPDATE_DOCUMENT_PIECE";
export const SET_UPDATE_DOCUMENT_PIECE = "SET_UPDATE_DOCUMENT_PIECE";

export const FORGOT_PWD = "FORGOT_PWD";
export const SET_FORGOT_PWD = "SET_FORGOT_PWD";
export const CLEAR_FORGOT_PWD = "CLEAR_FORGOT_PWD";

export const VERIFY_OTP_FORGOT_PWD = "VERIFY_OTP_FORGOT_PWD";
export const SET_VERIFY_OTP_FORGOT_PWD = "SET_VERIFY_OTP_FORGOT_PWD";
export const CLEAR_VERIFY_OTP_FORGOT_PWD = "CLEAR_VERIFY_OTP_FORGOT_PWD";

export const RESET_PWD = "RESET_PWD";
export const SET_RESET_PWD = "SET_RESET_PWD";
export const CLEAR_RESET_PWD = "CLEAR_RESET_PWD";

export const SET_PRET_CONNECTE = "SET_PRET_CONNECTE";
export const SET_MONTANT = "SET_MONTANT";
export const SET_DONNEES_PRO = "SET_DONNEES_PRO";
export const SET_NATURE_CREDIT = "SET_NATURE_CREDIT";

export const CREATE_SIMULATION = "CREATE_SIMULATION";
export const SET_CREATE_SIMULATION = "SET_CREATE_SIMULATION";
export const CLEAR_CREATE_SIMULATION = "CLEAR_CREATE_SIMULATION";

export const CONFIG_PASSWORD = "CONFIG_PASSWORD";
export const SET_CONFIG_PASSWORD = "SET_CONFIG_PASSWORD";
export const CLEAR_CONFIG_PASSWORD = "CLEAR_CONFIG_PASSWORD";

export const CONFIG_PASSWORD_INSCRIPTION = "CONFIG_PASSWORD_INSCRIPTION";
export const SET_CONFIG_PASSWORD_INSCRIPTION =
    "SET_CONFIG_PASSWORD_INSCRIPTION";
export const CLEAR_CONFIG_PASSWORD_INSCRIPTION =
    "CLEAR_CONFIG_PASSWORD_INSCRIPTION";

export const GET_SECTEURS_ACTIVITE = "GET_SECTEURS_ACTIVITE";
export const SET_SECTEURS_ACTIVITE = "SET_SECTEURS_ACTIVITE";

export const GET_DEMANDES = "GET_DEMANDES";
export const SET_DEMANDES = "SET_DEMANDES";

export const GET_SCORING = "GET_SCORING";
export const SET_SCORING = "SET_SCORING";
export const CLEAR_SCORING = "CLEAR_SCORING";

export const SEND_DEMANDE_PRET_CONNECTE = "SEND_DEMANDE_PRET_CONNECTE";
export const SET_DEMANDE_PRET_CONNECTE = "SET_DEMANDE_PRET_CONNECTE";
export const CLEAR_DEMANDE_PRET_CONNECTE = "CLEAR_DEMANDE_PRET_CONNECTE";

export const GET_DETAILS_DEMANDE = "GET_DETAILS_DEMANDE";
export const SET_DETAILS_DEMANDE = "SET_DETAILS_DEMANDE";

export const GET_CLIENT_DETAILS = "GET_CLIENT_DETAILS";
export const SET_CLIENT_DETAILS = "SET_CLIENT_DETAILS";

export const CREATE_SIMULATION_CONNECTE = "CREATE_SIMULATION_CONNECTE";
export const SET_CREATE_SIMULATION_CONNECTE = "SET_CREATE_SIMULATION_CONNECTE";
export const CLEAR_CREATE_SIMULATION_CONNECTE =
    "CLEAR_CREATE_SIMULATION_CONNECTE";

export const CLEAR_PRET_CONNECTE = "CLEAR_PRET_CONNECTE";

export const RESEND_OTP = "RESEND_OTP";
export const SET_RESEND_OTP = "SET_RESEND_OTP";
export const CLEAR_RESEND_OTP = "CLEAR_RESEND_OTP";
export const CLEAR_DONNEES_PRO = "CLEAR_DONNEES_PRO";

export const GET_SCORING_CONNECTE = "GET_SCORING_CONNECTE";
export const SET_SCORING_CONNECTE = "SET_SCORING_CONNECTE";
export const CLEAR_SCORING_CONNECTE = "CLEAR_SCORING_CONNECTE";

export const CHOOSE_AGENCE = "CHOOSE_AGENCE";
export const SET_CHOOSE_AGENCE = "SET_CHOOSE_AGENCE";
export const CLEAR_CHOOSE_AGENCE = "CLEAR_CHOOSE_AGENCE";

export const DELETE_DOCUMENT_PIECE = "DELETE_DOCUMENT_PIECE";
export const SET_DELETE_DOCUMENT_PIECE = "SET_DELETE_DOCUMENT_PIECE";
export const CLEAR_DELETE_DOCUMENT_PIECE = "CLEAR_DELETE_DOCUMENT_PIECE";

export const RESEND_OTP_MAIL = "RESEND_OTP_MAIL";
export const SET_RESEND_OTP_MAIL = "SET_RESEND_OTP_MAIL";
export const CLEAR_RESEND_OTP_MAIL = "CLEAR_RESEND_OTP_MAIL";

export const RESEND_OTP_SMS = "RESEND_OTP_SMS";
export const SET_RESEND_OTP_SMS = "SET_RESEND_OTP_SMS";
export const CLEAR_RESEND_OTP_SMS = "CLEAR_RESEND_OTP_SMS";

export const SEND_AUTH_DGSN = "SEND_AUTH_DGSN";
export const SET_AUTH_DGSN = "SET_AUTH_DGSN";
export const CLEAR_AUTH_DGSN = "CLEAR_AUTH_DGSN";

export const GET_DETAILS_DGSN = "GET_DETAILS_DGSN";
export const SET_DETAILS_DGSN = "SET_DETAILS_DGSN";
export const CLEAR_DETAILS_DGSN = "CLEAR_DETAILS_DGSN";

export const SEND_AUTH_DGSN_CONNECTED = "SEND_AUTH_DGSN_CONNECTED";
export const SET_AUTH_DGSN_CONNECTED = "SET_AUTH_DGSN_CONNECTED";
export const CLEAR_AUTH_DGSN_CONNECTED = "CLEAR_AUTH_DGSN_CONNECTED";

export const SEND_SIGN_DIGITALE = "SEND_SIGN_DIGITALE";
export const SET_SIGN_DIGITALE = "SET_SIGN_DIGITALE";
export const CLEAR_SIGN_DIGITALE = "CLEAR_SIGN_DIGITALE";

export const CHOOSE_SIGNATURE = "CHOOSE_SIGNATURE";
export const SET_CHOOSE_SIGNATURE = "SET_CHOOSE_SIGNATURE";
export const CLEAR_CHOOSE_SIGNATURE = "CLEAR_CHOOSE_SIGNATURE";

export const GET_STATUT_SIGNATURE = "GET_STATUT_SIGNATURE";
export const SET_STATUT_SIGNATURE = "SET_STATUT_SIGNATURE";
export const CLEAR_STATUT_SIGNATURE = "CLEAR_STATUT_SIGNATURE";

export const SEND_OTP_MAIL = "SEND_OTP_MAIL";
export const SET_OTP_MAIL = "SET_OTP_MAIL";
export const CLEAR_OTP_MAIL = "CLEAR_OTP_MAIL";

export const SEND_VERIFY_MAIL = "SEND_VERIFY_MAIL";
export const SET_VERIFY_MAIL = "SET_VERIFY_MAIL";
export const CLEAR_VERIFY_MAIL = "CLEAR_VERIFY_MAIL";

export const SET_DETAILS = "SET_DETAILS";

export const SEND_REMINDER = "SEND_REMINDER";
export const SET_REMINDER = "SET_REMINDER";
export const CLEAR_REMINDER = "CLEAR_REMINDER";

export const SIGN_OTP = "SIGN_OTP";
export const SET_SIGN_OTP = "SET_SIGN_OTP";
export const CLEAR_SIGN_OTP = "CLEAR_SIGN_OTP";

export const SEND_INSCRIPTION_DONNEES = "SEND_INSCRIPTION_DONNEES";
export const SET_INSCRIPTION_DONNEES = "SET_INSCRIPTION_DONNEES";
export const CLEAR_INSCRIPTION_DONNEES = "CLEAR_INSCRIPTION_DONNEES";

export const SEND_INSCRIPTION_CONTACT = "SEND_INSCRIPTION_CONTACT";
export const SET_INSCRIPTION_CONTACT = "SET_INSCRIPTION_CONTACT";
export const CLEAR_INSCRIPTION_CONTACT = "CLEAR_INSCRIPTION_CONTACT";

export const SEND_LOGIN = "SEND_LOGIN";
export const SET_LOGIN = "LOGIN_OTP";
export const CLEAR_LOGIN = "CLEAR_LOGIN";

export const SITUATION_CLIENT = "SITUATION_CLIENT";
export const SET_SITUATION_CLIENT = "SET_SITUATION_CLIENT";
export const CLEAR_SITUATION_CLIENT = "CLEAR_SITUATION_CLIENT";

export const GET_DETAIL_DOSSIER = "GET_DETAIL_DOSSIER";
export const SET_DETAIL_DOSSIER = "SET_DETAIL_DOSSIER";
export const CLEAR_DETAIL_DOSSIER = "CLEAR_DETAIL_DOSSIER";

export const VERIFIER_DGSN_DOSSIER = "VERIFIER_DGSN_DOSSIER";
export const SET_VERIFIER_DGSN_DOSSIER = "SET_VERIFIER_DGSN_DOSSIER";
export const CLEAR_VERIFIER_DGSN_DOSSIER = "CLEAR_VERIFIER_DGSN_DOSSIER";
export const SEND_OTP_CONTRACT = "SEND_OTP_CONTRACT";
export const SET_OTP_CONTRACT = "SET_OTP_CONTRACT";
export const CLEAR_OTP_CONTRACT = "CLEAR_OTP_CONTRACT";

export const VERIFY_OTP_CONTRACT = "VERIFY_OTP_CONTRACT";
export const SET_VERIFY_OTP_CONTRACT = "SET_VERIFY_OTP_CONTRACT";
export const CLEAR_VERIFY_OTP_CONTRACT = "CLEAR_VERIFY_OTP_CONTRACT";

export const CREATE_PS = "CREATE_PS";
export const SET_PS = "SET_PS";
export const CLEAR_PS = "CLEAR_PS";

export const CREATE_PS_CONNECTE = "CREATE_PS_CONNECTE";
export const SET_PS_CONNECTE = "SET_PS_CONNECTE";
export const CLEAR_PS_CONNECTE = "CLEAR_PS_CONNECTE";

export const GET_NEW_SIMULATION = "GET_NEW_SIMULATION";
export const SET_NEW_SIMULATION = "SET_NEW_SIMULATION";
export const CLEAR_NEW_SIMULATION = "CLEAR_NEW_SIMULATION";

export const UPDATE_NEW_SIMULATION = "UPDATE_NEW_SIMULATION";
export const SET_UPDATE_SIMULATION = "SET_UPDATE_SIMULATION";
export const CLEAR_UPDATE_SIMULATION = "CLEAR_UPDATE_SIMULATION";

export const GET_BAREMES = "GET_BAREMES";
export const SET_BAREMES = "SET_BAREMES";
export const CLEAR_BAREMES = "CLEAR_BAREMES";

export const SET_PROMO = "SET_PROMO";

export const SIMULATE_PROMO = "SIMULATE_PROMO";
export const SET_SIMULATE_PROMO = "SET_SIMULATE_PROMO";
export const CLEAR_SIMULATE_PROMO = "CLEAR_SIMULATE_PROMO";

export const CREATE_PROMO = "CREATE_PROMO";
export const SET_CREATE_PROMO = "SET_CREATE_PROMO";
export const CLEAR_CREATE_PROMO = "CLEAR_CREATE_PROMO";

export const SEND_CHECK_PARTENAIRE = "SEND_CHECK_PARTENAIRE";
export const SET_CHECK_PARTENAIRE = "SET_CHECK_PARTENAIRE";
export const CLEAR_CHECK_PARTENAIRE = "CLEAR_CHECK_PARTENAIRE";

export const SEND_OTP_PARTENAIRE = "SEND_OTP_PARTENAIRE";
export const SET_OTP_PARTENAIRE = "SET_OTP_PARTENAIRE";
export const CLEAR_OTP_PARTENAIRE = "CLEAR_OTP_PARTENAIRE";

export const VERIFY_OTP_PARTENAIRE = "VERIFY_OTP_PARTENAIRE";
export const SET_VERIFY_OTP_PARTENAIRE = "SET_VERIFY_OTP_PARTENAIRE";
export const CLEAR_VERIFY_OTP_PARTENAIRE = "CLEAR_VERIFY_OTP_PARTENAIRE";

export const SET_PARTENAIRE = "SET_PARTENAIRE";
export const CLEAR_PARTENAIRE = "CLEAR_PARTENAIRE";

export const GET_OFFRES_DETAILS = "GET_OFFRES_DETAILS";
export const SET_OFFRES_DETAILS = "SET_OFFRES_DETAILS";
export const CLEAR_OFFRES_DETAILS = "CLEAR_OFFRES_DETAILS";

export const SET_OFFRE_PARAM = "SET_OFFRE_PARAM";

export const GET_LOGOUT = "GET_LOGOUT";

export const LOGIN_CIN = "LOGIN_CIN";
export const SET_LOGIN_CIN = "SET_LOGIN_CIN";
export const CLEAR_LOGIN_CIN = "CLEAR_LOGIN_CIN";

export const VERIFY_OTP_LOGIN_CIN = "VERIFY_OTP_LOGIN_CIN";
export const SET_VERIFY_OTP_LOGIN_CIN = "SET_VERIFY_OTP_LOGIN_CIN";
export const CLEAR_VERIFY_OTP_LOGIN_CIN = "CLEAR_VERIFY_OTP_LOGIN_CIN";

export const GET_LOUEUR_DETAILS = "GET_LOUEUR_DETAILS";

export const GET_DOSSIERS_LOUEUR = "GET_DOSSIERS_LOUEUR";
export const SET_DOSSIERS_LOUEUR = "SET_DOSSIERS_LOUEUR";

export const VERIFY_OTP_UPDATE_NUM = "VERIFY_OTP_UPDATE_NUM";
export const SET_VERIFY_OTP_UPDATE_NUM = "SET_VERIFY_OTP_UPDATE_NUM";
export const CLEAR_VERIFY_OTP_UPDATE_NUM = "CLEAR_VERIFY_OTP_UPDATE_NUM";

export const DOUBLE_VERIFY_OTP_UPDATE_NUM = "DOUBLE_VERIFY_OTP_UPDATE_NUM";
export const SET_DOUBLE_VERIFY_OTP_UPDATE_NUM =
    "SET_DOUBLE_VERIFY_OTP_UPDATE_NUM";
export const CLEAR_DOUBLE_VERIFY_OTP_UPDATE_NUM =
    "CLEAR_DOUBLE_VERIFY_OTP_UPDATE_NUM";

export const apiStart = label => ({
    type: API_START,
    payload: label
});

export const apiEnd = label => ({
    type: API_END,
    payload: label
});

export const accessDenied = url => ({
    type: ACCESS_DENIED,
    payload: {
        url
    }
});

export const apiError = error => ({
    type: API_ERROR,
    error
});

export const tokenExpired = error => ({
    type: TOKEN_EXPIRED,
    error
});

function apiAction({
    url = "",
    method = "GET",
    privateAPI = true,
    data = null,
    accessToken = null,
    onSuccess = () => {},
    onFailure = () => {},
    label = "",
    headersOverride = null
}) {
    return {
        type: API,
        payload: {
            url,
            method,
            data,
            accessToken,
            onSuccess,
            onFailure,
            label,
            headersOverride,
            privateAPI
        }
    };
}

/******************** FUNCTIONS ********************/

export const sendAuth = (username, password) => {
    return apiAction({
        url: BACKEND_URL + "/auth",
        method: "POST",
        data: { username: username, password: password },
        privateAPI: false,
        onSuccess: setAuthData,
        onFailure: () =>
            console.log("Error occured loading authentification data"),
        label: SEND_AUTH
    });
};

export function setAuthData(data) {
    return {
        type: SET_AUTH,
        payload: data
    };
}

export function getFaqs() {
    return apiAction({
        url: BACKEND_URL + "",
        method: "GET",
        onSuccess: setFaqs,
        onFailure: () => null,
        label: GET_FAQS,
        privateAPI: false
    });
}

export function setFaqs(data) {
    return {
        type: SET_FAQS,
        payload: data
    };
}

export function getProfessions() {
    return apiAction({
        url: BACKEND_URL + "/ref/profession",
        method: "GET",
        onSuccess: setProfessions,
        onFailure: () => null,
        label: GET_PROFESSIONS,
        privateAPI: false
    });
}

export function setProfessions(data) {
    return {
        type: SET_PROFESSIONS,
        payload: data
    };
}

export function getProfessionBareme(codeProfession) {
    return apiAction({
        url: BACKEND_URL + "/bareme/get?codeProfession=" + codeProfession,
        method: "GET",
        onSuccess: setProfessionBareme,
        onFailure: () => null,
        label: GET_PROFESSION_BAREME,
        privateAPI: false
    });
}

export function setProfessionBareme(data) {
    return {
        type: SET_PROFESSION_BAREME,
        payload: data
    };
}

export function sendSimulation(data) {
    return apiAction({
        url: BACKEND_URL + "/simulation/calcul",
        method: "POST",
        onSuccess: setSimulation,
        onFailure: () => null,
        data: data,
        label: SEND_SIMULATION,
        privateAPI: false
    });
}

export function setSimulation(data) {
    return {
        type: SET_SIMULATION,
        payload: data
    };
}
export function clearSimulationData() {
    return {
        type: CLEAR_SIMULATION
    };
}

export function sendSimulationAuto(data) {
    return apiAction({
        url: BACKEND_URL + "/simulation/creditAuto/calcul",
        method: "POST",
        onSuccess: setSimulationAuto,
        onFailure: () => null,
        data: data,
        label: SEND_SIMULATION_AUTO,
        privateAPI: false
    });
}

export function setSimulationAuto(data) {
    return {
        type: SET_SIMULATION_AUTO,
        payload: data
    };
}
export function setSimResult(data) {
    return {
        type: SET_SIM_RESULT,
        payload: data
    };
}

export function clearSimResult() {
    return {
        type: CLEAR_SIM_RESULT
    };
}

export const verifyOtp = (id, data) => {
    return apiAction({
        url: BACKEND_URL + "/client/verify-otp/" + id,
        method: "PUT",
        data: data,
        onSuccess: setVerifyToken,
        onFailure: () => console.log("Error occurred verifying otp"),
        label: SEND_VERIFY_OTP
    });
};

export function setVerifyToken(data) {
    return {
        type: SET_VERIFY_OTP,
        payload: data
    };
}

export const verifyOtpInscription = (id, data) => {
    return apiAction({
        url: BACKEND_URL + "/client/inscription/verify-otp/" + id,
        method: "PUT",
        data: data,
        onSuccess: setVerifyOTPInscription,
        onFailure: () => console.log("Error occurred verifying otp"),
        label: SEND_VERIFY_OTP_INSCRIPTION
    });
};

export function setVerifyOTPInscription(data) {
    return {
        type: SET_VERIFY_OTP_INSCRIPTION,
        payload: data
    };
}

export const addClient = data => {
    return apiAction({
        url: BACKEND_URL + "/client/add",
        method: "POST",
        data: data,
        onSuccess: setClient,
        onFailure: () => console.log("Error occurred adding client"),
        label: ADD_CLIENT
    });
};

export function setClient(data) {
    return {
        type: SET_CLIENT,
        payload: data
    };
}

export const sendDemandePret = data => {
    return apiAction({
        url: BACKEND_URL + "/client/add/demandePret",
        method: "POST",
        data: data,
        onSuccess: setDemandePret,
        onFailure: () => null,
        label: SEND_DEMANDE_PRET
    });
};

export function setDemandePret(data) {
    return {
        type: SET_DEMANDE_PRET,
        payload: data
    };
}

export const changePassword = () => {
    return apiAction({
        url: BACKEND_URL + "/client/change-password",
        method: "POST",
        onSuccess: setChangePassword,
        onFailure: () => null,
        privateAPI: true,
        label: CHANGE_PASSWORD
    });
};

export function setChangePassword(data) {
    return {
        type: SET_CHANGE_PASSWORD,
        payload: data
    };
}

export const verifyOtpPassword = data => {
    return apiAction({
        url: BACKEND_URL + "/client/verify-otp/password",
        method: "PUT",
        data: data,
        onSuccess: setVerifyOtpPassword,
        onFailure: () => null,
        privateAPI: true,
        label: VERIFY_OTP_PASSWORD
    });
};

export function setVerifyOtpPassword(data) {
    return {
        type: SET_VERIFY_OTP_PASSWORD,
        payload: data
    };
}

export const updatePhone = data => {
    return apiAction({
        url: BACKEND_URL + "/client/update/phone",
        data: data,
        method: "POST",
        onSuccess: setUpdatePhone,
        onFailure: () => null,
        privateAPI: true,
        label: UPDATE_PHONE
    });
};

export function setUpdatePhone(data) {
    return {
        type: SET_UPDATE_PHONE,
        payload: data
    };
}

export const verifyOtpPhone = data => {
    return apiAction({
        url: BACKEND_URL + "/client/verify-otp/phone",
        method: "PUT",
        data: data,
        onSuccess: setVerifyOtpPhone,
        onFailure: () => null,
        privateAPI: true,
        label: VERIFY_OTP_PHONE
    });
};

export function setVerifyOtpPhone(data) {
    return {
        type: SET_VERIFY_OTP_PHONE,
        payload: data
    };
}

export const updateMail = email => {
    return apiAction({
        url: BACKEND_URL + "/client/update/email?email=" + email,
        method: "POST",
        onSuccess: setUpdateMail,
        onFailure: () => null,
        privateAPI: true,
        label: UPDATE_MAIL
    });
};

export function setUpdateMail(data) {
    return {
        type: SET_UPDATE_MAIL,
        payload: data
    };
}

export const verifyOtpMail = data => {
    return apiAction({
        url: BACKEND_URL + "/client/verify-otp/email",
        method: "PUT",
        data: data,
        onSuccess: setVerifyOtpMail,
        onFailure: () => null,
        privateAPI: true,
        label: VERIFY_OTP_MAIL
    });
};

export function setVerifyOtpMail(data) {
    return {
        type: SET_VERIFY_OTP_MAIL,
        payload: data
    };
}

export const getDonneesCompte = () => {
    return apiAction({
        url: BACKEND_URL + "/client/get/contact",
        method: "GET",
        onSuccess: setDonneesCompte,
        onFailure: () => null,
        privateAPI: true,
        label: GET_DONNEES_COMPTE
    });
};

export function setDonneesCompte(data) {
    return {
        type: SET_DONNEES_COMPTE,
        payload: data
    };
}

export const getDocuments = id => {
    return apiAction({
        url: BACKEND_URL + "/document/" + id,
        method: "GET",
        onSuccess: setDocuments,
        onFailure: () => null,
        privateAPI: true,
        label: GET_DOCUMENTS
    });
};

export function setDocuments(data) {
    return {
        type: SET_DOCUMENTS,
        payload: data
    };
}

export const uploadDocumentPiece = (id, data) => {
    return apiAction({
        url: BACKEND_URL + "/document/upload/" + id,
        method: "POST",
        data: data,
        onSuccess: setUploadDocumentPiece,
        onFailure: () => null,
        privateAPI: true,
        label: UPLOAD_DOCUMENT_PIECE
    });
};

export function setUploadDocumentPiece(data) {
    return {
        type: SET_UPLOAD_DOCUMENT_PIECE,
        payload: data
    };
}

export const updateDocumentPiece = (id, data) => {
    return apiAction({
        url: BACKEND_URL + "/document/update/" + id,
        method: "PUT",
        data: data,
        onSuccess: setUpdateDocumentPiece,
        onFailure: () => null,
        privateAPI: true,
        label: UPDATE_DOCUMENT_PIECE
    });
};

export function setUpdateDocumentPiece(data) {
    return {
        type: SET_UPDATE_DOCUMENT_PIECE,
        payload: data
    };
}

/******************** SET ********************/
export function addReclamation(formData) {
    return apiAction({
        url: BACKEND_URL + "/reclamation/add",
        method: "POST",
        onSuccess: setAddReclamation,
        onFailure: () => null,
        data: formData,
        /*   headers: {
            "Content-Type": "multipart/form-data" // Optionnel, souvent géré automatiquement
        }, */
        label: ADD_RECLAMATION,
        privateAPI: false
    });
}

export function setAddReclamation(data) {
    return {
        type: SET_ADD_RECLAMATION,
        payload: data
    };
}

export function getAgencesList() {
    return apiAction({
        url: BACKEND_URL + "/ref/agences/all",
        method: "GET",
        onSuccess: setAgencesList,
        onFailure: () => null,
        label: GET_AGENCES,
        privateAPI: false
    });
}

export function setAgencesList(data) {
    return {
        type: SET_AGENCES,
        payload: data
    };
}

export function forgotPwd(data) {
    return apiAction({
        url: BACKEND_URL + "/client/forgot-password",
        method: "POST",
        data: data,
        onSuccess: setForgotPwd,
        onFailure: () => null,
        label: FORGOT_PWD,
        privateAPI: false
    });
}

export function setForgotPwd(data) {
    return {
        type: SET_FORGOT_PWD,
        payload: data
    };
}

export function verifyOtpForgotPwd(data) {
    return apiAction({
        url: BACKEND_URL + "/client/verify-otp/forgot-password",
        method: "PUT",
        data: data,
        onSuccess: setVerifyOtpForgotPwd,
        onFailure: () => null,
        label: VERIFY_OTP_FORGOT_PWD,
        privateAPI: false
    });
}

export function setVerifyOtpForgotPwd(data) {
    return {
        type: SET_VERIFY_OTP_FORGOT_PWD,
        payload: data
    };
}

export function resetPwd(data) {
    return apiAction({
        url: BACKEND_URL + "/client/reset-password",
        method: "PUT",
        data: data,
        onSuccess: setResetPwd,
        onFailure: () => null,
        label: RESET_PWD,
        privateAPI: false
    });
}

export function setResetPwd(data) {
    return {
        type: SET_RESET_PWD,
        payload: data
    };
}

export function setPretConnecte(data) {
    return {
        type: SET_PRET_CONNECTE,
        payload: data
    };
}
export function setDonneesPro(data) {
    return {
        type: SET_DONNEES_PRO,
        payload: data
    };
}
export function setMontant(data) {
    return {
        type: SET_MONTANT,
        payload: data
    };
}
export function setNatureCredit(data) {
    return {
        type: SET_NATURE_CREDIT,
        payload: data
    };
}

export function createSimulation(data) {
    return apiAction({
        url: BACKEND_URL + "/simulation/create",
        method: "POST",
        data: data,
        onSuccess: setCreateSimulation,
        onFailure: () => null,
        label: CREATE_SIMULATION,
        privateAPI: false
    });
}

export function setCreateSimulation(data) {
    return {
        type: SET_CREATE_SIMULATION,
        payload: data
    };
}

export function createSimulationConnecte(data) {
    return apiAction({
        url: BACKEND_URL + "/simulation/connect/create",
        method: "POST",
        data: data,
        onSuccess: setCreateSimulationConnecte,
        onFailure: () => null,
        label: CREATE_SIMULATION_CONNECTE,
        privateAPI: true
    });
}

export function setCreateSimulationConnecte(data) {
    return {
        type: SET_CREATE_SIMULATION_CONNECTE,
        payload: data
    };
}

export function configPassword(id, data) {
    return apiAction({
        url: BACKEND_URL + "/config-mdp/" + id,
        method: "POST",
        data: data,
        onSuccess: setConfigPassword,
        onFailure: () => null,
        label: CONFIG_PASSWORD,
        headersOverride: {
            "content-type": "multipart/form-data"
        },
        privateAPI: false
    });
}

export function setConfigPassword(data) {
    return {
        type: SET_CONFIG_PASSWORD,
        payload: data
    };
}

export function configPasswordInscription(id, data) {
    return apiAction({
        url: BACKEND_URL + "/inscription/config-mdp/" + id,
        method: "POST",
        data: data,
        onSuccess: setConfigPasswordInscription,
        onFailure: () => null,
        label: CONFIG_PASSWORD_INSCRIPTION,
        headersOverride: {
            "content-type": "multipart/form-data"
        },
        privateAPI: false
    });
}

export function setConfigPasswordInscription(data) {
    return {
        type: SET_CONFIG_PASSWORD_INSCRIPTION,
        payload: data
    };
}

export function getSecteursActivite() {
    return apiAction({
        url: BACKEND_URL + "/ref/secteurActivite",
        method: "GET",
        onSuccess: setSecteursActivite,
        onFailure: () => null,
        label: GET_SECTEURS_ACTIVITE,
        privateAPI: false
    });
}

export function setSecteursActivite(data) {
    return {
        type: SET_SECTEURS_ACTIVITE,
        payload: data
    };
}

export function getDemandes() {
    return apiAction({
        url: BACKEND_URL + "/demande-credit/get-all",
        method: "GET",
        onSuccess: setDemandes,
        onFailure: () => null,
        label: GET_DEMANDES
    });
}

export function setDemandes(data) {
    return {
        type: SET_DEMANDES,
        payload: data
    };
}
export function getScoring(id) {
    return apiAction({
        url: BACKEND_URL + "/demande-credit/" + id,
        method: "POST",
        onSuccess: setScoring,
        onFailure: () => null,
        label: GET_SCORING,
        privateAPI: false
    });
}

export function setScoring(data) {
    return {
        type: SET_SCORING,
        payload: data
    };
}

export function sendDemandePretConnecte(id, data) {
    return apiAction({
        url: BACKEND_URL + "/client/add/demandeCredit/" + id,
        method: "POST",
        data: data,
        onSuccess: setDemandePretConnecte,
        onFailure: () => null,
        label: SEND_DEMANDE_PRET_CONNECTE,
        privateAPI: true
    });
}

export function setDemandePretConnecte(data) {
    return {
        type: SET_DEMANDE_PRET_CONNECTE,
        payload: data
    };
}

export const getDetailsDemande = id => {
    return apiAction({
        url: BACKEND_URL + "/demande-credit/" + id,
        method: "GET",
        onSuccess: setDetailsDemande,
        onFailure: () => null,
        privateAPI: true,
        label: GET_DETAILS_DEMANDE
    });
};

export function setDetailsDemande(data) {
    return {
        type: SET_DETAILS_DEMANDE,
        payload: data
    };
}

export const getClientDetails = () => {
    return apiAction({
        url: BACKEND_URL + "/client/get/detail",
        method: "GET",
        onSuccess: setClientDetails,
        onFailure: () => null,
        privateAPI: true,
        label: GET_CLIENT_DETAILS
    });
};

export const getLoueurDetails = () => {
    return apiAction({
        url: BACKEND_URL + "/loueur/detail",
        method: "GET",
        onSuccess: setClientDetails,
        onFailure: () => null,
        privateAPI: true,
        label: GET_LOUEUR_DETAILS
    });
};

export function setClientDetails(data) {
    return {
        type: SET_CLIENT_DETAILS,
        payload: data
    };
}

export const resendOtp = id => {
    return apiAction({
        url: BACKEND_URL + "/client/resend-otp/" + id,
        method: "GET",
        onSuccess: setResendOtp,
        onFailure: () => null,
        privateAPI: true,
        label: RESEND_OTP
    });
};

export function setResendOtp(data) {
    return {
        type: SET_RESEND_OTP,
        payload: data
    };
}

export function getScoringConnecte(id) {
    return apiAction({
        url: BACKEND_URL + "/demande-credit/create/" + id,
        method: "POST",
        onSuccess: setScoringConnecte,
        onFailure: () => null,
        label: GET_SCORING_CONNECTE,
        privateAPI: true
    });
}

export function setScoringConnecte(data) {
    return {
        type: SET_SCORING_CONNECTE,
        payload: data
    };
}

export function chooseAgence(idAgence, idPret) {
    return apiAction({
        url:
            BACKEND_URL +
            "/demande-credit/choixAgence?idAgence=" +
            idAgence +
            "&idPret=" +
            idPret,
        method: "POST",
        onSuccess: setChoosingAgence,
        onFailure: () => null,
        label: CHOOSE_AGENCE,
        privateAPI: true
    });
}

export function setChoosingAgence(data) {
    return {
        type: SET_CHOOSE_AGENCE,
        payload: data
    };
}

export function deleteDocument(data, id) {
    return apiAction({
        url: BACKEND_URL + "/document/delete/" + id,
        data: data,
        method: "DELETE",
        onSuccess: setDeleteDocument,
        onFailure: () => null,
        label: DELETE_DOCUMENT_PIECE,
        privateAPI: true
    });
}

export function setDeleteDocument(data) {
    return {
        type: SET_DELETE_DOCUMENT_PIECE,
        payload: data
    };
}

export const resendOtpMail = data => {
    return apiAction({
        url: BACKEND_URL + "/client/resend-otp-email",
        method: "GET",
        data: data,
        onSuccess: setResendOtpMail,
        onFailure: () => null,
        privateAPI: true,
        label: RESEND_OTP_MAIL
    });
};

export function setResendOtpMail(data) {
    return {
        type: SET_RESEND_OTP_MAIL,
        payload: data
    };
}

export const resendOtpSms = data => {
    return apiAction({
        url: BACKEND_URL + "/client/resend-otp-sms",
        method: "GET",
        data: data,
        onSuccess: setResendOtpSms,
        onFailure: () => null,
        privateAPI: true,
        label: RESEND_OTP_SMS
    });
};

export function setResendOtpSms(data) {
    return {
        type: SET_RESEND_OTP_SMS,
        payload: data
    };
}

export const sendAuthDGSN = id => {
    return apiAction({
        url: BACKEND_URL + "/public/initAuth?idSimulation=" + id,
        method: "GET",
        onSuccess: setAuthDGSN,
        onFailure: () => null,
        privateAPI: false,
        label: SEND_AUTH_DGSN
    });
};

export function setAuthDGSN(data) {
    return {
        type: SET_AUTH_DGSN,
        payload: data
    };
}

export const getDetailsDGSN = id => {
    return apiAction({
        url: BACKEND_URL + "/client/" + id,
        method: "GET",
        onSuccess: setDetailsDGSN,
        onFailure: () => null,
        privateAPI: false,
        label: GET_DETAILS_DGSN
    });
};

export function setDetailsDGSN(data) {
    return {
        type: SET_DETAILS_DGSN,
        payload: data
    };
}

export const sendAuthConnectedDGSN = id => {
    return apiAction({
        url: BACKEND_URL + "/client/initAuth?idRequete=" + id,
        method: "GET",
        onSuccess: setAuthConnectedDGSN,
        onFailure: () => null,
        privateAPI: true,
        label: SEND_AUTH_DGSN_CONNECTED
    });
};

export function setAuthConnectedDGSN(data) {
    return {
        type: SET_AUTH_DGSN_CONNECTED,
        payload: data
    };
}

export const sendSignatureDigitale = id => {
    return apiAction({
        url: BACKEND_URL + "/demande-credit/sign-contrat/" + id,
        method: "POST",
        onSuccess: setSignatureDigitale,
        onFailure: () => null,
        privateAPI: true,
        label: SEND_SIGN_DIGITALE
    });
};

export function setSignatureDigitale(data) {
    return {
        type: SET_SIGN_DIGITALE,
        payload: data
    };
}

export const chooseSignature = (id, choixSignature, dateRdv) => {
    return apiAction({
        url:
            BACKEND_URL +
            "/demande-credit/choix-signature/" +
            id +
            "?choixSignature=" +
            choixSignature +
            (dateRdv ? "&dateRdv=" + dateRdv : ""),
        method: "POST",
        onSuccess: setChooseSignature,
        onFailure: () => null,
        privateAPI: true,
        label: CHOOSE_SIGNATURE
    });
};

export function setChooseSignature(data) {
    return {
        type: SET_CHOOSE_SIGNATURE,
        payload: data
    };
}

export const getStatutSignature = id => {
    return apiAction({
        url: BACKEND_URL + "/demande-credit/contrat/status/" + id,
        method: "GET",
        onSuccess: setStatutSignature,
        onFailure: () => null,
        privateAPI: true,
        label: GET_STATUT_SIGNATURE
    });
};

export function setStatutSignature(data) {
    return {
        type: SET_STATUT_SIGNATURE,
        payload: data
    };
}

export const sendOtpMail = email => {
    return apiAction({
        url: BACKEND_URL + "/client/verify-email/send-otp?email=" + email,
        method: "POST",
        privateAPI: true,
        onSuccess: setOtpMail,
        onFailure: () => console.log("Error occurred sending otp"),
        label: SEND_OTP_MAIL
    });
};

export function setOtpMail(data) {
    return {
        type: SET_OTP_MAIL,
        payload: data
    };
}

export const verifyMail = data => {
    return apiAction({
        url: BACKEND_URL + "/client/verify-email/verify-otp",
        method: "GET",
        data: data,
        privateAPI: true,
        onSuccess: setVerifyMail,
        onFailure: () => console.log("Error occurred verifying otp"),
        label: SEND_VERIFY_MAIL
    });
};

export function setVerifyMail(data) {
    return {
        type: SET_VERIFY_MAIL,
        payload: data
    };
}

export function setDetails(data) {
    return {
        type: SET_DETAILS,
        payload: data
    };
}

export const sendReminder = data => {
    return apiAction({
        url: BACKEND_URL + "/simulation/reminder",
        method: "POST",
        data: data,
        privateAPI: false,
        onSuccess: setReminder,
        onFailure: () => console.log("Error occurred sending reminder"),
        label: SEND_REMINDER
    });
};

export function setReminder(data) {
    return {
        type: SET_REMINDER,
        payload: data
    };
}

export const signOtp = data => {
    return apiAction({
        url: BACKEND_URL + "/client/singing-otp",
        method: "POST",
        data: data,
        privateAPI: false,
        onSuccess: setSignOtp,
        onFailure: () => console.log("Error occurred sending otp"),
        label: SIGN_OTP
    });
};

export function setSignOtp(data) {
    return {
        type: SET_SIGN_OTP,
        payload: data
    };
}

export const sendLogin = data => {
    return apiAction({
        url: BACKEND_URL + "/login",
        method: "POST",
        data: data,
        privateAPI: false,
        onSuccess: setLogin,
        onFailure: () => console.log("Error occurred login"),
        label: SEND_LOGIN
    });
};

export function setLogin(data) {
    return {
        type: SET_LOGIN,
        payload: data
    };
}

export const sendInscriptionDonnees = data => {
    return apiAction({
        url: BACKEND_URL + "/client/inscription",
        method: "POST",
        data: data,
        onSuccess: setInscriptionDonnees,
        onFailure: () =>
            console.log("Error occurred sending inscription donnees"),
        label: SEND_INSCRIPTION_DONNEES
    });
};

export function setInscriptionDonnees(data) {
    return {
        type: SET_INSCRIPTION_DONNEES,
        payload: data
    };
}

export const sendInscriptionContact = (idClient, data) => {
    return apiAction({
        url: BACKEND_URL + "/client/add/contact/" + idClient,
        method: "POST",
        data: data,
        onSuccess: setInscriptionContact,
        onFailure: () =>
            console.log("Error occurred sending inscription contact"),
        label: SEND_INSCRIPTION_CONTACT
    });
};

export function setInscriptionContact(data) {
    return {
        type: SET_INSCRIPTION_CONTACT,
        payload: data
    };
}

export const getSituationClient = () => {
    return apiAction({
        url: BACKEND_URL + "/client/situation",
        method: "GET",
        privateAPI: true,
        onSuccess: setSituationClient,
        onFailure: () => console.log("Error occurred situation client"),
        label: SITUATION_CLIENT
    });
};

export function setSituationClient(data) {
    return {
        type: SET_SITUATION_CLIENT,
        payload: data
    };
}
export const clearSituationClient = () => ({
    type: CLEAR_SITUATION_CLIENT
});

export const getDetailDossier = id => {
    return apiAction({
        url: BACKEND_URL + "/client/dossier/" + id,
        method: "GET",
        privateAPI: true,
        onSuccess: setDetailDossier,
        onFailure: () => console.log("Error occurred situation client"),
        label: GET_DETAIL_DOSSIER
    });
};

export function setDetailDossier(data) {
    return {
        type: SET_DETAIL_DOSSIER,
        payload: data
    };
}
export const clearDetailDossier = () => ({
    type: CLEAR_DETAIL_DOSSIER
});

export const verifierDGSNDossier = () => {
    return apiAction({
        url: BACKEND_URL + "/initAuth",
        method: "GET",
        privateAPI: true,
        onSuccess: setverifierDGSNDossier,
        onFailure: () => console.log("Error occurred verifi DGSN dossier"),
        label: VERIFIER_DGSN_DOSSIER
    });
};

export function setverifierDGSNDossier(data) {
    return {
        type: SET_VERIFIER_DGSN_DOSSIER,
        payload: data
    };
}
export const clearverifierDGSNDossier = () => ({
    type: CLEAR_VERIFIER_DGSN_DOSSIER
});
export const sendOtpContract = () => {
    return apiAction({
        url: BACKEND_URL + "/client/consult-contract/send-otp",
        method: "GET",
        privateAPI: true,
        onSuccess: setOtpContract,
        onFailure: () => console.log("Error occurred otp"),
        label: SEND_OTP_CONTRACT
    });
};

export function setOtpContract(data) {
    return {
        type: SET_OTP_CONTRACT,
        payload: data
    };
}

export const verifyOtpContract = data => {
    return apiAction({
        url: BACKEND_URL + "/client/consult-contract/verify-otp",
        method: "PUT",
        data: data,
        privateAPI: true,
        onSuccess: setVerifyOtpContract,
        onFailure: () => console.log("Error occurred otp"),
        label: VERIFY_OTP_CONTRACT
    });
};

export function setVerifyOtpContract(data) {
    return {
        type: SET_VERIFY_OTP_CONTRACT,
        payload: data
    };
}

export const createPS = id => {
    return apiAction({
        url: BACKEND_URL + "/demande-credit/create-ps/" + id,
        method: "POST",
        privateAPI: false,
        onSuccess: setPS,
        onFailure: () => console.log("Error occurred ps"),
        label: CREATE_PS
    });
};

export function setPS(data) {
    return {
        type: SET_PS,
        payload: data
    };
}

export const createPsConnecte = id => {
    return apiAction({
        url: BACKEND_URL + "/demande-credit/ps/" + id,
        method: "POST",
        privateAPI: true,
        onSuccess: setPsConnecte,
        onFailure: () => console.log("Error occurred ps"),
        label: CREATE_PS_CONNECTE
    });
};

export function setPsConnecte(data) {
    return {
        type: SET_PS_CONNECTE,
        payload: data
    };
}

export const getNewSimulation = id => {
    return apiAction({
        url: BACKEND_URL + "/demande-credit/get/simulations/" + id,
        method: "GET",
        privateAPI: true,
        onSuccess: setNewSimulation,
        onFailure: () => console.log("Error occurred simulation"),
        label: GET_NEW_SIMULATION
    });
};

export function setNewSimulation(data) {
    return {
        type: SET_NEW_SIMULATION,
        payload: data
    };
}

export const updateNewSimulation = (id, isAccepted) => {
    return apiAction({
        url:
            BACKEND_URL +
            "/demande-credit/update/simulation/" +
            id +
            "?isAccepted=" +
            isAccepted,
        method: "POST",
        privateAPI: true,
        onSuccess: setUpdateSimulation,
        onFailure: () => console.log("Error occurred simulation"),
        label: UPDATE_NEW_SIMULATION
    });
};

export function setUpdateSimulation(data) {
    return {
        type: SET_UPDATE_SIMULATION,
        payload: data
    };
}

export const getBaremes = () => {
    return apiAction({
        url: BACKEND_URL + "/bareme/get/offre",
        method: "GET",
        privateAPI: false,
        onSuccess: setBaremes,
        onFailure: () => console.log("Error occurred baremes"),
        label: GET_BAREMES
    });
};

export function setBaremes(data) {
    return {
        type: SET_BAREMES,
        payload: data
    };
}

export function setPromo(data) {
    return {
        type: SET_PROMO,
        payload: data
    };
}

export const simulatePromo = data => {
    return apiAction({
        url: BACKEND_URL + "/simulation/calcul",
        method: "POST",
        data: data,
        privateAPI: false,
        onSuccess: setSimulatePromo,
        onFailure: () => console.log("Error occurred baremes"),
        label: SIMULATE_PROMO
    });
};

export function setSimulatePromo(data) {
    return {
        type: SET_SIMULATE_PROMO,
        payload: data
    };
}

export const createPromo = data => {
    return apiAction({
        url: BACKEND_URL + "/simulation/offre/create",
        method: "POST",
        data: data,
        privateAPI: false,
        onSuccess: setCreatePromo,
        onFailure: () => console.log("Error occurred baremes"),
        label: CREATE_PROMO
    });
};

export function setCreatePromo(data) {
    return {
        type: SET_CREATE_PROMO,
        payload: data
    };
}

export const checkPartenaire = idPret => {
    return apiAction({
        url: BACKEND_URL + "/client/partenaire/check?idPret=" + idPret,
        method: "POST",
        privateAPI: false,
        onSuccess: setCheckPartenaire,
        onFailure: () => console.log("Error occurred baremes"),
        label: SEND_CHECK_PARTENAIRE
    });
};

export function setCheckPartenaire(data) {
    return {
        type: SET_CHECK_PARTENAIRE,
        payload: data
    };
}

export const sendOtpPartenaire = idClient => {
    return apiAction({
        url: BACKEND_URL + "/client/partenaire/send-otp/" + idClient,
        method: "GET",
        privateAPI: false,
        onSuccess: setOtpPartenaire,
        onFailure: () => console.log("Error occurred baremes"),
        label: SEND_OTP_PARTENAIRE
    });
};

export function setOtpPartenaire(data) {
    return {
        type: SET_OTP_PARTENAIRE,
        payload: data
    };
}

export const verifyOtpPartenaire = (idClient, data) => {
    return apiAction({
        url: BACKEND_URL + "/client/partenaire/verify-otp/" + idClient,
        method: "PUT",
        data: data,
        privateAPI: false,
        onSuccess: setVerifyOtpPartenaire,
        onFailure: () => console.log("Error occurred baremes"),
        label: VERIFY_OTP_PARTENAIRE
    });
};

export function setVerifyOtpPartenaire(data) {
    return {
        type: SET_VERIFY_OTP_PARTENAIRE,
        payload: data
    };
}

export function setPartenaire(data) {
    return {
        type: SET_PARTENAIRE,
        payload: data
    };
}

export const getOffresDetails = () => {
    return apiAction({
        url: BACKEND_URL + "/bareme/get/offres",
        method: "GET",
        privateAPI: false,
        onSuccess: setOffresDetails,
        onFailure: () => console.log("Error occurred offres details"),
        label: GET_OFFRES_DETAILS
    });
};

export function setOffresDetails(data) {
    return {
        type: SET_OFFRES_DETAILS,
        payload: data
    };
}

export function setOffreParam(data) {
    return {
        type: SET_OFFRE_PARAM,
        payload: data
    };
}

export const onLogout = () => {
    return apiAction({
        url: BACKEND_URL + "/logout",
        method: "POST",
        privateAPI: true,
        onSuccess: clearLoginData,
        onFailure: () => console.log("Error occurred logging out"),
        label: GET_LOGOUT
    });
};

export const authenticateLoginCIN = data => {
    return apiAction({
        url: BACKEND_URL + "/request-otp",
        method: "POST",
        data: data,
        privateAPI: false,
        onSuccess: setAuthenticateLoginCIN,
        onFailure: () => console.log("Error occurred login CIN"),
        label: LOGIN_CIN
    });
};

export function setAuthenticateLoginCIN(data) {
    return {
        type: SET_LOGIN_CIN,
        payload: data
    };
}
export const verifyOtpLoginCIN = data => {
    return apiAction({
        url: BACKEND_URL + "/verify-otp",
        method: "POST",
        data: data,
        privateAPI: false,
        onSuccess: setVerifyOtpLoginCIN,
        onFailure: () =>
            console.log("Error occurred verifying OTP for login CIN"),
        label: VERIFY_OTP_LOGIN_CIN
    });
};

export function setVerifyOtpLoginCIN(data) {
    return {
        type: SET_VERIFY_OTP_LOGIN_CIN,
        payload: data
    };
}

export function getDossiersLoueur() {
    return apiAction({
        url: BACKEND_URL + "/loueur/dossiers/get",
        method: "GET",
        onSuccess: setDossiersLoueur,
        onFailure: () => null,
        label: GET_DOSSIERS_LOUEUR,
        privateAPI: true
    });
}

export function setDossiersLoueur(data) {
    return {
        type: SET_DOSSIERS_LOUEUR,
        payload: data
    };
}

export function sendOtpUpdateAncienNum() {
    return apiAction({
        url: BACKEND_URL + "/client/check/phone",
        method: "GET",
        onSuccess: setVerifyOtpUpdateNum,
        onFailure: () => null,
        label: VERIFY_OTP_UPDATE_NUM,
        privateAPI: true
    });
}

export function setVerifyOtpUpdateNum(data) {
    return {
        type: SET_VERIFY_OTP_UPDATE_NUM,
        payload: data
    };
}

export const verifyOtpUpdateAncienNum = data => {
    return apiAction({
        url: BACKEND_URL + "/client/verify-otp/check-phone",
        method: "PUT",
        data: data,
        privateAPI: true,
        onSuccess: setDoubleVerifyOtpUpdateNum,
        onFailure: () =>
            console.log(
                "Error occurred verifying OTP for updating phone number"
            ),
        label: DOUBLE_VERIFY_OTP_UPDATE_NUM
    });
};

export function setDoubleVerifyOtpUpdateNum(data) {
    return {
        type: SET_DOUBLE_VERIFY_OTP_UPDATE_NUM,
        payload: data
    };
}
/******************** CLEAR ********************/

export const clearLoginData = () => ({
    type: CLEAR_DECONNEXION
});
export const clearAddReclamation = () => ({
    type: CLEAR_ADD_RECLAMATION
});

export const clearVerifyOtpMail = () => ({
    type: CLEAR_VERIFY_OTP_MAIL
});

export const clearVerifyOtpPhone = () => ({
    type: CLEAR_VERIFY_OTP_PHONE
});

export const clearVerifyOtpPassword = () => ({
    type: CLEAR_VERIFY_OTP_PASSWORD
});

export const clearChangePassword = () => ({
    type: CLEAR_CHANGE_PASSWORD
});

export const clearUpdateMail = () => ({
    type: CLEAR_UPDATE_MAIL
});

export const clearUpdatePhone = () => ({
    type: CLEAR_UPDATE_PHONE
});

export const clearForgotPwd = () => ({
    type: CLEAR_FORGOT_PWD
});
export const clearVerifyOtpForgotPwd = () => ({
    type: CLEAR_VERIFY_OTP_FORGOT_PWD
});
export const clearResetPwd = () => ({
    type: CLEAR_RESET_PWD
});
export const clearCreateSimulation = () => ({
    type: CLEAR_CREATE_SIMULATION
});
export const clearCreateSimulationConnecte = () => ({
    type: CLEAR_CREATE_SIMULATION_CONNECTE
});
export const clearScoring = () => ({
    type: CLEAR_SCORING
});
export const clearDemandePretConnecte = () => ({
    type: CLEAR_DEMANDE_PRET_CONNECTE
});
export const clearConfigPassword = () => ({
    type: CLEAR_CONFIG_PASSWORD
});
export const clearConfigPasswordInscription = () => ({
    type: CLEAR_CONFIG_PASSWORD_INSCRIPTION
});
export const clearPretConnecte = () => ({
    type: CLEAR_PRET_CONNECTE
});
export const clearResendOtp = () => ({
    type: CLEAR_RESEND_OTP
});
export const clearScoringConnecte = () => ({
    type: CLEAR_SCORING_CONNECTE
});
export const clearDonneesPro = () => ({
    type: CLEAR_DONNEES_PRO
});
export const clearChoosingAgence = () => ({
    type: CLEAR_CHOOSE_AGENCE
});
export const clearDeleteDocument = () => ({
    type: CLEAR_DELETE_DOCUMENT_PIECE
});
export const clearResendOtpMail = () => ({
    type: CLEAR_RESEND_OTP_MAIL
});
export const clearResendOtpSms = () => ({
    type: CLEAR_RESEND_OTP_SMS
});
export const clearAuthDGSN = () => ({
    type: CLEAR_AUTH_DGSN
});
export const clearDetailsDGSN = () => ({
    type: CLEAR_DETAILS_DGSN
});
export const clearAuthConnectedDGSN = () => ({
    type: CLEAR_AUTH_DGSN_CONNECTED
});
export const clearSignatureDigitale = () => ({
    type: CLEAR_SIGN_DIGITALE
});
export const clearChooseSignature = () => ({
    type: CLEAR_CHOOSE_SIGNATURE
});
export const clearStatutSignature = () => ({
    type: CLEAR_STATUT_SIGNATURE
});
export const clearOtpMail = () => ({
    type: CLEAR_OTP_MAIL
});
export const clearVerifyMail = () => ({
    type: CLEAR_VERIFY_MAIL
});
export const clearAddClient = () => ({
    type: CLEAR_CLIENT
});
export const clearInscriptionDonnees = () => ({
    type: CLEAR_INSCRIPTION_DONNEES
});
export const clearInscriptionContact = () => ({
    type: CLEAR_INSCRIPTION_CONTACT
});
export const clearDemandePret = () => ({
    type: CLEAR_DEMANDE_PRET
});
export const clearReminder = () => ({
    type: CLEAR_REMINDER
});
export const clearSignOtp = () => ({
    type: CLEAR_SIGN_OTP
});
export const clearLogin = () => ({
    type: CLEAR_LOGIN
});
export const clearOtpContract = () => ({
    type: CLEAR_OTP_CONTRACT
});
export const clearVerifyContract = () => ({
    type: CLEAR_VERIFY_OTP_CONTRACT
});
export const clearPS = () => ({
    type: CLEAR_PS
});
export const clearPsConnecte = () => ({
    type: CLEAR_PS_CONNECTE
});
export const clearNewSimulation = () => ({
    type: CLEAR_NEW_SIMULATION
});
export const clearUpdateSimulation = () => ({
    type: CLEAR_UPDATE_SIMULATION
});
export const clearBaremes = () => ({
    type: CLEAR_BAREMES
});
export const clearSimulatePromo = () => ({
    type: CLEAR_SIMULATE_PROMO
});
export const clearCreatePromo = () => ({
    type: CLEAR_CREATE_PROMO
});
export const clearCheckPartenaire = () => ({
    type: CLEAR_CHECK_PARTENAIRE
});
export const clearSendOtpPartenaire = () => ({
    type: CLEAR_OTP_PARTENAIRE
});
export const clearVerifyOtpPartenaire = () => ({
    type: CLEAR_VERIFY_OTP_PARTENAIRE
});
export const clearPartenaire = () => ({
    type: CLEAR_PARTENAIRE
});
export const clearOffresDetails = () => ({
    type: CLEAR_OFFRES_DETAILS
});

export const clearLoginCIN = () => ({
    type: CLEAR_LOGIN_CIN
});
export const clearVerifyOtpLoginCIN = () => ({
    type: CLEAR_VERIFY_OTP_LOGIN_CIN
});
export const clearVerifyOtpUpdateNum = () => ({
    type: CLEAR_VERIFY_OTP_UPDATE_NUM
});
export const clearDoubleVerifyOtpUpdateNum = () => ({
    type: CLEAR_DOUBLE_VERIFY_OTP_UPDATE_NUM
});
